import { addMessage } from '../config/chatUtils';
import { setCurrentFlow, getCurrentFlow } from '../config/chatState';

// SUPPORT FLOW
let supportFlowActive = false; // Track if support flow is active

function startSupportFlow(first = null) {
    setCurrentFlow('support');

    if (first) {
        addMessage("Send a message to your support team", "user", 500);
    }
    addMessage("Our support team will be happy to assist you! Give me a moment while I pull up the form.", 'bot', 1250);

    setTimeout(() => { chatInput.disabled = true; }, 1500);
    setTimeout(() => {
        const contactUsModal = new bootstrap.Modal(
            document.getElementById("contactUsModal")
        );
        contactUsModal.show();
        supportFlowActive = true; // Set flag to true when modal opens
    }, 2500);
}

// Handle form submission and modal close
document.addEventListener("DOMContentLoaded", function () {
    const contactUsModal = document.getElementById("contactUsModal");
    const supportForm = document.querySelector('.contact-cast-form');

    // Only set up listeners if the contact support elements exist
    if (!contactUsModal || !supportForm) return;

    // Listen for Gravity Form submission
    supportForm.addEventListener("submit", function () {
        sessionStorage.setItem('contactForm', "submitted");
    });

    // Detect when modal is closed
    contactUsModal.addEventListener("hidden.bs.modal", function () {
        if (supportFlowActive) {
            const contactForm = sessionStorage.getItem('contactForm');
            if (contactForm === "submitted") {
                whatsNextHelp('support'); // User submitted the form
                setTimeout(() => { sessionStorage.removeItem('contactForm'); }, 1000);
            } else {
                whatsNextHelp(); // User closed without submitting
            }
        }
        supportFlowActive = false;
    });
});